export default __webpack_public_path__ + "static/media/st-logo.57a79570.png";